import React, { useState } from 'react';

export default function EditableTitle({ title, onSave, className }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(title);

  const handleSave = (e) => {
    if (e) {
      e.stopPropagation();
    }
    onSave(editedTitle);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <input
        type="text"
        value={editedTitle}
        onChange={(e) => setEditedTitle(e.target.value)}
        onBlur={(e) => handleSave(e)}
        onKeyDown={(e) => {
          e.stopPropagation();
          if (e.key === 'Enter') handleSave();
          if (e.key === 'Escape') {
            setEditedTitle(title);
            setIsEditing(false);
          }
        }}
        onClick={(e) => e.stopPropagation()}
        className={`bg-dark-300 px-3 py-1 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent-primary ${className}`}
        autoFocus
      />
    );
  }

  return (
    <h2 
      className={`cursor-pointer hover:text-accent-primary transition-colors ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        setIsEditing(true);
      }}
    >
      {title}
    </h2>
  );
} 